import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ICTPlaceholderPml, STPlaceholderType, DeltaOf, ShapeDataModel } from '@tencent/slide-sdk-model';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { TextConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/text/text-converter';
import { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import { IPlaceholder } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/shape-model-props.interface';

export class PlaceholderConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTPlaceholderPml>>,
        uiData: IElementBaseModel,
    ): void {
        if (sdkData.type !== undefined || sdkData.idx !== undefined) {
            uiData.isPlaceholder = true;
            uiData.placeHolder = {
                type: sdkData.type !== undefined ? STPlaceholderType[sdkData.type] : undefined,
                index: sdkData.idx !== undefined ? sdkData.idx : undefined,
            };
        }
    }

    /**
     * 数据3.0转换接口
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IPlaceholder>,
        sdkData: DeltaOf<ICTPlaceholderPml>,
    ): void {
        if (uiData.type !== undefined) {
            sdkData.type = STPlaceholderType[uiData.type];
        }
        if (uiData.index !== undefined) {
            sdkData.idx = uiData.index;
        }
    }

    /**
     * 占位符的文本是否是在母版编辑时编辑过的
     * @param uiData
     */
    public static convertCustomPrompt(uiData: IShapeModel): number {
        if (!uiData.sdkData) {
            return 0;
        }
        const sdkData = uiData.sdkData as unknown as ShapeDataModel;
        const layoutSdkShape = sdkData.getRelatedPlaceholder?.();
        return layoutSdkShape?.props?.nvPr?.ph?.hasCustomPrompt ? 1 : 0;
    }

    /**
     * 母版编辑时编辑过的占位符文本
     * @param uiData
     */
    public static convertCustomPromptParagraphList(uiData: IShapeModel): IParagraph[] {
        if (!uiData.sdkData) {
            return [];
        }
        const sdkData = uiData.sdkData as unknown as ShapeDataModel;
        const layoutSdkShape = sdkData.getRelatedPlaceholder?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tempShape = {} as IShapeModel;
        if (layoutSdkShape?.props?.txBody) {
            TextConverter.convertPartialDataFromSdkToUi(layoutSdkShape?.props?.txBody, tempShape);
        }
        return tempShape.paragraphList || [];
    }
}
